import type { KidForm } from '../interfaces'
import type { KidStore } from './interfaces'

export const actions = {
  setKid (this: KidStore, payload: KidStore['kid']): void {
    this.kid = payload
    this.form = {
      name: payload?.name ?? '',
      grade: payload?.grade ?? null,
      voip: payload?.voip ?? null,
      notes: payload?.notes ?? null,
    }
  },
  setFormField<K extends keyof KidForm> (this: KidStore, key: K, value: KidForm[K]): void {
    this.form[key] = value
  },
  setCustomerIsGo (this: KidStore, payload: KidStore['customerIsGo']): void {
    this.customerIsGo = payload
  },
  trackProcessing (this: KidStore, isStarted: boolean): void {
    this.processing = Math.max(0, this.processing + (isStarted ? 1 : -1))
  },
  setModalDelete (this: KidStore, payload: KidStore['modalDelete']): void {
    this.modalDelete = payload
  },
  setModalAddDiscipline (this: KidStore, payload: KidStore['modalAddDiscipline']): void {
    this.modalAddDiscipline = payload
  },
  reset (this: KidStore): void {
    this.kid = null
    this.form = { name: '', grade: null, voip: null, notes: null }
    this.customerIsGo = false
    this.processing = 0
    this.modalDelete = false
    this.modalAddDiscipline = false
  },
}
